/* eslint-disable max-len */
import types from '../types'
import 'firebase/compat/auth'
import 'firebase/compat/database'

export const setEditPrompt = (database, moduleKey, taskName, prompt) => (dispatch) => {
  const dbRef = database.ref(`prompts/${moduleKey}/${taskName}`)
  return dbRef
      .set(prompt)
      .then(() => {
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            userMessage: 'Prompt updated',
            notificationIcon: 'check',
            notificationType: 2,
          },
        })
      })
      .catch((err) => {
        console.log('error', err)
        dispatch({
          type: types.STORE_PAYLOAD,
          payload: {
            userMessage: 'Prompt update failure',
            notificationIcon: 'warning',
            notificationType: 3,
          },
        })
      })
}
